import { Fragment } from "react";
import { useLocation, useParams } from "react-router-dom";
import SEO from "../../components/seo";
import LayoutTwo from "../../layouts/LayoutTwo";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import BlogSidebar from "../../wrappers/blog/BlogSidebar";
// import BlogComment from "../../wrappers/blog/BlogComment";
import BlogPostCard from "../../wrappers/blog/BlogPostCard";

const BlogDetailsStandard = () => {
  let { pathname } = useLocation();
  const customerStoreLink = useParams();
  const storeCustomerCode = customerStoreLink?.CustomerCode;

  return (
    <Fragment>
      <SEO titleTemplate="Blog Post" description="Blog Post" />
      <LayoutTwo>
        {/* breadcrumb */}
        <Breadcrumb
          pages={[
            { label: "Home", path: `/${storeCustomerCode}` },
            { label: "Blog Post", path: pathname },
          ]}
        />
        <div className="blog-area pt-40 pb-100">
          <div className="container">
            <div className="row">
              {" "}
              {/*  this property is work to old code ___flex-row-reverse */}
              <div className="col-lg-7">
                <div className="blog-details-wrapper ml-20">
                  {/* blog post */}
                  <BlogPostCard />

                  {/* blog post comment */}
                  {/* <BlogComment /> */}
                </div>
              </div>
              <div className="col-lg-5">
                {/* blog sidebar */}
                <BlogSidebar />
              </div>
            </div>
          </div>
        </div>
      </LayoutTwo>
    </Fragment>
  );
};

export default BlogDetailsStandard;
